module.exports = __webpack_public_path__ + "img/er6.db63e618.png";